// src/lib/constants/appContent.ts

import { ListlistTypeId } from '@lib2/model/listlist/ListlistType';

// ── Listlist Type Labels ──
export const LISTLIST_TYPE_LABELS: Record<ListlistTypeId, string> = {
  [ListlistTypeId.Root]: 'Content Group',
  [ListlistTypeId.Category]: 'Category',
  [ListlistTypeId.Series]: 'Series',
};

// ── Constraints ──
export const CONTENT_CONSTRAINTS = {
  TITLE_MIN: 1,
  TITLE_MAX: 150,
  DESC_SHORT_MAX: 150,
} as const;

// ── Query Keys ──
export const APP_CONTENT_QUERY_KEYS = {
  all: ['appContent'] as const,
  listlists: (cId: number) => [...APP_CONTENT_QUERY_KEYS.all, 'listlists', cId] as const,
  positions: (cId: number) => [...APP_CONTENT_QUERY_KEYS.all, 'positions', cId] as const,
  positionsByRoot: (cId: number, rootLlId: number) =>
    [...APP_CONTENT_QUERY_KEYS.positions(cId), rootLlId] as const,
  detail: (cId: number, llId: number) =>
    [...APP_CONTENT_QUERY_KEYS.all, 'detail', cId, llId] as const,
} as const;
